<form [formGroup]="formGroup">
  <div class="form-group row">
    <div class="col-md-5">
      <label class="label-common">Tên HTX</label>
    </div>
    <div class="col-md-12">
      <span>{{cooperativeName}}</span>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-md-12">
      <dcu-input-text label="Mã Trạm" formControlName="stationCode" [required]="true"></dcu-input-text>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-md-12">
      <dcu-input-text label="Tên Trạm" formControlName="stationName"></dcu-input-text>
    </div>
  </div>
</form>
